import { render, staticRenderFns } from "./YoungChat.vue?vue&type=template&id=63306950&scoped=true&"
import script from "./YoungChat.vue?vue&type=script&lang=js&"
export * from "./YoungChat.vue?vue&type=script&lang=js&"
import style0 from "./YoungChat.vue?vue&type=style&index=0&id=63306950&prod&scoped=true&lang=css&"
import style1 from "./YoungChat.vue?vue&type=style&index=1&id=63306950&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63306950",
  null
  
)

export default component.exports